import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TemplateAccess } from '../../../../../models/template-access';

@Component({
  selector: 'lib-affected-areas-list',
  templateUrl: './affected-areas-list.component.html',
  styleUrls: ['./affected-areas-list.component.scss']
})
export class AffectedAreasListComponent implements OnInit {
  templateAccess!: TemplateAccess;
  columns: { key: string; header: string; selection: string }[] = [
    {
      key: 'riskAffectedDepartments',
      header: 'riskTemplates.manageAccess.departments',
      selection: 'allDepartments'
    },
    {
      key: 'riskAffectedResources',
      header: 'riskTemplates.manageAccess.resources',
      selection: 'allResources'
    },
    {
      key: 'riskAffectedSites',
      header: 'riskTemplates.manageAccess.sites',
      selection: 'allSites'
    },
    {
      key: 'riskAffectedVendors',
      header: 'riskTemplates.manageAccess.thirdParties',
      selection: 'allVendors'
    }
  ];

  allThirdPartiesLabels = {
    riskAffectedDepartments: 'riskTemplates.manageAccess.allDepartments',
    riskAffectedResources: 'riskTemplates.manageAccess.allResources',
    riskAffectedVendors: 'riskTemplates.manageAccess.allThirdParties',
    riskAffectedSites: 'riskTemplates.manageAccess.allSites'
  };

  constructor(private config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.templateAccess = this.config.data.templateAccess;
  }

}
